import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import CameraGrid from "@/components/command/CameraGrid";
import StadiumMap from "@/components/command/StadiumMap";
import IncidentTimeline from "@/components/command/IncidentTimeline";
import KpiStrip from "@/components/command/KpiStrip";
import ZoneDetailsDrawer from "@/components/command/ZoneDetailsDrawer";
import DemoDirector from "@/components/command/DemoDirector";

export default function CommandCenter() {
  const { bootstrap, alerts, kpi } = useOutletContext();
  const [zoneId, setZoneId] = useState(null);

  const cameras = bootstrap?.cameras ?? [];
  const zones = bootstrap?.zones ?? [];

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Slim title row */}
      <div className="h-10 flex items-center justify-between px-4 border-b border-border bg-[hsl(var(--surface))] shrink-0">
        <div className="flex items-baseline gap-3">
          <h1 className="font-display font-black uppercase tracking-tight text-sm leading-none">
            Command Center
          </h1>
          <span className="micro-label hidden sm:inline">Single Pane of Glass · Realtime Ops</span>
        </div>
        <DemoDirector />
      </div>

      <KpiStrip bootstrap={bootstrap} kpi={kpi} alerts={alerts} />

      {/* Main canvas — cameras dominate, map right, timeline bottom */}
      <div className="flex-1 grid grid-cols-1 xl:grid-cols-3 grid-rows-[1fr_auto] gap-2 p-2 overflow-hidden min-h-0">
        <div className="xl:col-span-2 panel overflow-hidden min-h-0">
          <CameraGrid cameras={cameras} alerts={alerts} />
        </div>
        <div className="panel overflow-hidden min-h-0">
          <StadiumMap zones={zones} alerts={alerts} onZoneClick={(z) => z && setZoneId(z.id)} />
        </div>
        <div className="xl:col-span-3 panel overflow-hidden h-32 shrink-0">
          <IncidentTimeline alerts={alerts} />
        </div>
      </div>

      <ZoneDetailsDrawer zoneId={zoneId} onClose={() => setZoneId(null)} />
    </div>
  );
}
